import api from '../../../utils/api';

export const LEGACY_WORD_CONVERTED_PDF_LIMIT_BYTES = 80 * 1024 * 1024;

export const convertLegacyWordToPdf = async ({ roomId, file }) => {
  const normalizedRoomId = String(roomId || '').trim();
  if (!normalizedRoomId) {
    throw new Error('This meeting room is not ready for legacy Word conversion.');
  }
  if (!file) throw new Error('Choose a legacy Word document to convert.');

  const body = new FormData();
  body.append('document', file, file.name || 'presentation.doc');
  const response = await api.post(
    `/rooms/${encodeURIComponent(normalizedRoomId)}/presentation/word-to-pdf`,
    body,
    {
      responseType: 'blob',
      // Override the API client's application/json default, but do not set a
      // multipart value manually. The browser must add the unique FormData
      // boundary to Content-Type.
      headers: { 'Content-Type': undefined },
      // Conversion may take longer than the normal API timeout for a large DOC.
      timeout: 90_000,
    }
  );
  const pdf = response?.data;
  if (!(pdf instanceof Blob) || pdf.size === 0) {
    throw new Error('The server did not return a converted PDF.');
  }
  if (pdf.size > LEGACY_WORD_CONVERTED_PDF_LIMIT_BYTES) {
    throw new Error('The converted PDF exceeds the 80 MB presentation limit.');
  }
  const responseType = String(pdf.type || '').toLowerCase();
  if (responseType && !['application/pdf', 'application/octet-stream'].includes(responseType)) {
    throw new Error('The server returned an invalid legacy Word conversion response.');
  }
  return responseType === 'application/pdf'
    ? pdf
    : new Blob([pdf], { type: 'application/pdf' });
};
